export default __webpack_public_path__ + "static/franchise-9-e4f6b72ed8c49634054c8a1789f47493.jpg";